import { NavBar } from "@portal-frontend-ssr/navbar";
import { LoaderFunctionArgs } from "@remix-run/node";
import { Outlet } from "@remix-run/react";
import { useLoaderData } from "@remix-run/react";
import { gameLayoutLoader } from "~/shared/loaders/gameLayoutLoader";
import { TournamentGameIdSchema } from "./shared";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const { success: gameIdSuccess, data: gameId } = TournamentGameIdSchema.safeParse(params.gameId?.toLowerCase());
  if (!gameIdSuccess) {
    throw new Response("Not Found", { status: 404 });
  }

  return await gameLayoutLoader({ gameId });
};

export const Component = () => {
  const { nav, tournamentTimelineData } = useLoaderData<typeof loader>();

  return (
    <>
      <NavBar navbarItems={nav.items} tournamentTimeline={tournamentTimelineData} />
      <Outlet />
    </>
  );
};

export default Component;
